import React, { useEffect, useContext, useState } from 'react';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import AuthContext from '../context/auth-context';

import { MdArrowBackIos, MdErrorOutline } from 'react-icons/md';

import Card from '../components/UI/Card';
import useGetPagos from '../hooks/useGetPagos';

const Pagos = () => {

    const authContext = useContext(AuthContext);
    const listaPagos = useGetPagos(authContext.token);
    const [error, setError] = useState(false);
	
	useEffect(() => {
		if(listaPagos.LOADING){
            return;
		}

		if(listaPagos.STATUS && listaPagos.STATUS === "SUCCESS"){
            setError(false);

        } else if(listaPagos.STATUS && listaPagos.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: listaPagos.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }

	}, [listaPagos]);

	return (
		<>
			{/* BUTTON REGRESAR */}
            <div className="row py-5">
                <div className="col-lg-8 offset-lg-2 mt-2">
                    <Link className="btn btn-outline-light border border-2 border-light shadow" style={{fontWeight: "500"}} to='/pago-admision'>
                        <MdArrowBackIos/> Regresar
                    </Link>
                </div>
            </div>

			{
				error && 
				<div className="row">
					<div className="col-lg-8 offset-lg-2 mb-5">
						<Card>
							<div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
								<div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
									<span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
									<br />
									¡Error!
								</div>
							</div>
						</Card>
					</div>
				</div>
			}
			{
				<div className="row">
					<div className="col-lg-8 offset-lg-2">
						<Card>
							<div className="card-body">
								<div className="row mt-4 mb-4">
									
									{/* TITULO */}
									<div className="col-md-10 offset-md-1">
										<h1 className="display-6 text-center text-secondary" style={{fontSize: '1.75rem', userSelect: 'none'}}>
											Mis pagos
										</h1>
										<div className="text-danger"><hr /></div>
									</div>

									{/* LISTA PAGOS */}
									<div className="col-md-10 offset-md-1">

										{/* LOADING */}
										{
											listaPagos.LOADING &&
											<div className="d-flex justify-content-center py-4">
												<div className="spinner-border text-danger" role="status">
													<span className="visually-hidden">Loading...</span>
												</div>
											</div>
										}

										{/* AUN NO HA REALIZADO NINGUN PAGO */}
										{
											listaPagos.PAGOS && listaPagos.PAGOS.length === 0 &&
											<div className="row" style={{ userSelect: 'none' }}>
												<div className="col-md-12 text-center">
													<h1 className="display-6 text-secondary" style={{ fontSize: '1.3rem' }}>No ha realizado ningún pago</h1>
													<div className="text-dark"><hr /></div>
												</div>
											</div>
											
										}
										
										{/* LISTA DE PAGOS */}
										{
											listaPagos.PAGOS && listaPagos.PAGOS.length > 0 &&
											listaPagos.PAGOS.map((pago,i) => {
												let colorEstado = "";
												let estiloEstado = {};

												if( pago.ESTADO === "CREADA" ){
													estiloEstado = { color: "#05549a" };
												} else if( pago.ESTADO === "APROBADA" ){
													colorEstado = "text-success";
												} else if( pago.ESTADO === "DENEGADA" || pago.ESTADO === "ERROR" ){
													colorEstado = "text-danger";
												}

												const monto = parseFloat(pago.MONTO).toFixed(2);
												
												return (
												<div key={i}>
													<div className="row" style={{ userSelect: 'none' }}>
														<div className="col-md-8" style={{ fontSize: '1.045rem' }}>
															<span className='fw-light'><b>Orden:</b> <span style={{ userSelect: 'text' }}>{pago.ORDEN_ID}</span></span>
															<br />
															<span className='fw-light'><b>Fecha:</b> {pago.FECHA}</span>
															<br />
															<span className='fw-light'><b>Estado:</b> <i className={colorEstado} style={estiloEstado}>{pago.ESTADO}</i></span>
														</div>
														<div className="col-md-4" style={{ textAlign: 'right' }}>
															<h1 className="display-6 text-dark" style={{ fontSize: '1.3rem' }}>$US {monto}</h1>
														</div>
													</div>
													<div className="text-dark"><hr /></div>
												</div>
											)})
										}
										
									</div>


								</div>
							</div>
						</Card>
					</div>
				</div>
			}
		</>
	);
}

export default Pagos;